<template>
  <div>
    <v-checkbox
      class="mt-0"
      hide-details
      v-if="showCheckBox"
      @change="change"
      v-model="item.checked"
    ></v-checkbox>
  </div>
</template>

<script>
import { orderItemStatus } from "@/utils/constants";

export default {
  props: {
    item: {
      type: Object,
    },
    childKey: {
      type: String,
    },
  },
  methods: {
    change(val) {
      const orderItems = [];
      this.item[this.childKey].forEach((child) => {
        if (child.state === orderItemStatus.PENDING_PURCHASE) {
          child.checked = val;
          orderItems.push(child);
        }
      });
      this.$emit("change", val, orderItems, this.item);
    },
    // these methods used outside of this component
    checkState() {
      this.item.checked = this.item[this.childKey].every(
        (item) =>
          item.checked || item.state !== orderItemStatus.PENDING_PURCHASE
      );
    },
    clearState() {
      this.item.checked = false;
      this.item[this.childKey].forEach((item) => {
        item.checked = false;
      });
    },
  },
  computed: {
    showCheckBox() {
      const hasAvailableProductToCreateContract =
        this.item[this.childKey] &&
        this.item[this.childKey].some((item) => {
          return (
            item.state === orderItemStatus.PENDING_PURCHASE &&
            !item["contractNumber"]
          );
        });
      return (
        this.item[this.childKey] &&
        this.item[this.childKey].length &&
        hasAvailableProductToCreateContract
      );
    },
  },
};
</script>
